import { applyMiddleware, compose, createStore } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import { autoRehydrate, persistStore } from 'redux-persist';
import thunk from 'redux-thunk';
import { createBrowserHistory } from 'history';
import { createBlacklistFilter } from 'redux-persist-transform-filter';
import clientMiddleware from './middleware/clientMiddleware';
import ApiClient from '../helpers/ApiClient';
import rootReducer from './modules';

export const history = createBrowserHistory();
export const client = new ApiClient();

const initialState = {};
const enhancers = [];
const middleware = [
  thunk,
  clientMiddleware(client),
  routerMiddleware(history),
];

if (process.env.NODE_ENV === 'development') {
  const devToolsExtension = window.devToolsExtension;

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension());
  }
}

const composedEnhancers = compose(
  applyMiddleware(...middleware),
  autoRehydrate(),
  ...enhancers,
);

const store = createStore(
  rootReducer,
  initialState,
  composedEnhancers,
);

const RequestBlacklistFilter = createBlacklistFilter(
  'request',
  ['requests', 'loading', 'itemsCount', 'alert'],
  'travelExpense',
  ['index', 'countries', 'amount', 'alert'],
);

const RequestsForManagerBlacklistFilter = createBlacklistFilter(
  'requestsForManager',
  ['selectedRequests', 'requests', 'loading', 'pageCount', 'alert'],
);

const RequestsForAccountingBlacklistFilter = createBlacklistFilter(
  'requestsForAccounting',
  ['selectedRequests', 'requests', 'loading', 'pageCount', 'alert'],
);

const RequestsForHrBlacklistFilter = createBlacklistFilter(
  'requestsForHr',
  [
    'selectedRequests',
    'requests',
    'selectedRequests',
    'loading',
    'pageCount',
    'alert'],
);

const travelExpenseBlacklistFilter = createBlacklistFilter(
  'travelExpense',
  ['index', 'countries', 'amount', 'alert'],
);

const authBlacklistFilter = createBlacklistFilter(
  'auth',
  ['error'],
);

export const persistor = persistStore(store, {
  transforms: [
    RequestBlacklistFilter,
    travelExpenseBlacklistFilter,
    RequestsForManagerBlacklistFilter,
    RequestsForAccountingBlacklistFilter,
    RequestsForHrBlacklistFilter,
    authBlacklistFilter,
  ],
});

export default store;



// WEBPACK FOOTER //
// ./src/redux/index.js